// extracted by mini-css-extract-plugin
module.exports = {"container":"IFrame_container__1k_6L","iframe":"IFrame_iframe__3JkPU"};